import React from 'react';

/**
 * Drop affordances for dragging a campaign from the sidebar onto the board.
 */
const FlowchartDropOverlay = ({
  campaignDragPos,
  isMultiCampaignDragOver,
  isMultiCampaignMode,
}) => (
  <>
    {campaignDragPos && !isMultiCampaignMode && (
      <div
        className="flowchart__campaign-drop-preview"
        style={{
          left: campaignDragPos.x,
          top: campaignDragPos.y,
        }}
      />
    )}

    {isMultiCampaignDragOver && isMultiCampaignMode && (
      <div className="flowchart__multi-campaign-drop-overlay">
        <div className="flowchart__multi-campaign-drop-content">
          <div className="flowchart__multi-campaign-drop-icon">+</div>
          <h3>Drop to add campaign</h3>
          <p>The campaign will be added to this view</p>
        </div>
      </div>
    )}
  </>
);

export default FlowchartDropOverlay;
